import React from "react";
import TransparentModal from "../../app/UI/Modal/TransparentModal";
import { closeModal } from "./modalActions";
import { connect } from "react-redux";

import CustomerITReportSpinner from "../reports/Merchant/CustomerITReport/CustomerITReportSpinner";

const actions = {
  closeModal,
};

const customerITReportSpinnerModal = ({ closeModal }) => {
  return (
    <TransparentModal modalHeader="Please Wait...." onClose={closeModal}>
      <CustomerITReportSpinner />
    </TransparentModal>
  );
};

export default connect(
  null,
  actions
)(customerITReportSpinnerModal);
